module.exports = __webpack_public_path__ + "img/internal-documents_0.37ffc850.svg";